import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import PostService from '../services/PostService';
import { useData } from '../context/DataContext';
import { normalizeImageUrl } from '../utils/imageUtils';

const PromotionPage = () => {
    const [posts, setPosts] = useState([]);
    const { postCategories } = useData();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(0);
    const pageSize = 9;
    const isFetchingRef = useRef(false);

    const fetchData = async (pageNum = 0) => {
        if (isFetchingRef.current) return;

        isFetchingRef.current = true;
        setLoading(true);
        try {
            const postsRes = await PostService.getPromotions(pageNum, pageSize);
            
            let allPosts = [];
            const postsData = postsRes?.data;
            if (Array.isArray(postsData)) {
                allPosts = postsData;
                setTotalPages(1);
                setTotalElements(postsData.length);
            } else if (postsData) {
                allPosts = postsData.content || postsData.items || postsData.data || [];
                setTotalPages(postsData.totalPages || 1);
                setTotalElements(postsData.totalElements || allPosts.length);
            }
            
            setPosts(allPosts);
        } catch (err) {
            console.error('Error fetching promotion page:', err);
        } finally {
            setLoading(false);
            isFetchingRef.current = false;
        }
    };

    useEffect(() => {
        if (postCategories && postCategories.length > 0) {
            fetchData(currentPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [currentPage, postCategories]);

    const filteredPosts = posts;

    return (
        <main style={{ paddingBottom: 60, borderBottom: '1px solid #ececec' }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Khuyến Mại
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                {/* Tiêu đề */}
                <h1 className="heading-primary text-center" style={{ margin: '0 0 32px' }}>
                    <span>Tin Khuyến Mại</span>
                </h1>

                {/* Danh sách khuyến mại */}
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-danger" role="status" />
                        <p className="mt-3 text-muted">Đang tải chương trình khuyến mại...</p>
                    </div>
                ) : filteredPosts.length === 0 ? (
                    <div className="text-center py-5">
                        <p className="text-muted" style={{ fontSize: 16 }}>Hiện chưa có chương trình khuyến mại nào.</p>
                    </div>
                ) : (
                    <>
                        <div className="row g-4">
                            {filteredPosts.map(post => (
                                <div key={post._id || post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        style={{
                                            background: '#fff', borderRadius: 12, overflow: 'hidden',
                                            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            height: '100%', display: 'flex', flexDirection: 'column',
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.14)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
                                        }}
                                    >
                                        {/* Badge khuyến mại */}
                                        <div style={{ position: 'relative' }}>
                                            <Link to={`/khuyen-mai/${post.slug || post._id || post.id}`} style={{ display: 'block', textDecoration: 'none' }}>
                                                <div style={{ height: 210, overflow: 'hidden', background: '#f5f5f5' }}>
                                                    {post.imageUrl ? (
                                                        <img
                                                            src={normalizeImageUrl(post.imageUrl)}
                                                            alt={post.title}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                                                            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                                                        />
                                                    ) : (
                                                        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 48 }}>🎁</div>
                                                    )}
                                                </div>
                                            </Link>
                                            {/* Hot badge */}
                                            <span style={{
                                                position: 'absolute', top: 12, left: 12,
                                                background: 'linear-gradient(135deg, #ff416c, #ff4b2b)',
                                                color: '#fff', fontSize: 11, fontWeight: 800,
                                                padding: '3px 10px', borderRadius: 999,
                                                boxShadow: '0 2px 8px rgba(255,65,108,0.4)',
                                                letterSpacing: 0.5,
                                            }}>
                                                🔥 HOT
                                            </span>
                                        </div>

                                        {/* Category badge */}
                                        {post.category && (
                                            <div style={{ padding: '10px 18px 0' }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: '#ff0000', background: '#fff5ec', borderRadius: 999, padding: '3px 10px', border: '1px solid #ffe0c2' }}>
                                                    {post.category}
                                                </span>
                                            </div>
                                        )}

                                        {/* Content */}
                                        <div style={{ padding: '12px 18px 18px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ fontSize: 12, color: '#aaa', marginBottom: 6 }}>
                                                {post.createdAt ? new Date(post.createdAt).toLocaleDateString('vi-VN') : ''}
                                            </div>
                                            <Link to={`/khuyen-mai/${post.slug || post._id || post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                <h3
                                                    style={{
                                                        fontSize: 15, fontWeight: 700, color: '#222',
                                                        lineHeight: 1.5, marginBottom: 10,
                                                        display: '-webkit-box', WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.color = '#ff0000'}
                                                    onMouseLeave={e => e.currentTarget.style.color = '#222'}
                                                >
                                                    {post.title}
                                                </h3>
                                            </Link>
                                            {post.description && (
                                                <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
                                                    {post.description}
                                                </p>
                                            )}
                                            <Link
                                                to={`/khuyen-mai/${post.slug || post._id || post.id}`}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                                    marginTop: 14, padding: '8px 18px',
                                                    background: '#ff0000', color: '#fff', borderRadius: 8,
                                                    fontSize: 13, fontWeight: 700, textDecoration: 'none',
                                                    transition: 'background 0.2s', alignSelf: 'flex-start',
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.background = '#e57218'}
                                                onMouseLeave={e => e.currentTarget.style.background = '#ff0000'}
                                            >
                                                Xem chi tiết →
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Phân trang */}
                        {totalPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 40 }}>
                                <button
                                    onClick={() => setCurrentPage(p => Math.max(0, p - 1))}
                                    disabled={currentPage === 0}
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #ddd',
                                        background: currentPage === 0 ? '#f5f5f5' : '#fff',
                                        cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: currentPage === 0 ? '#aaa' : '#333',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    ← Trước
                                </button>

                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setCurrentPage(i)}
                                        style={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: 8,
                                            border: currentPage === i ? 'none' : '1px solid #ddd',
                                            background: currentPage === i ? '#ff0000' : '#fff',
                                            color: currentPage === i ? '#fff' : '#333',
                                            fontWeight: 700,
                                            fontSize: 14,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))}
                                    disabled={currentPage >= totalPages - 1}
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 8,
                                        border: '1px solid #ddd',
                                        background: currentPage >= totalPages - 1 ? '#f5f5f5' : '#fff',
                                        cursor: currentPage >= totalPages - 1 ? 'not-allowed' : 'pointer',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: currentPage >= totalPages - 1 ? '#aaa' : '#333',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Sau →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </main>
    );
};

export default PromotionPage;



